<template>
  <v-container>
    <v-card-title class="pa-5 pb-3">
      <p class="font-weight-bold">アカウント削除</p>
    </v-card-title>
    <v-card-text class="pa-5 pt-0">
      <v-row>
        <v-col cols="12" md="9">
          <p class="font-weight-bold text-h6">アカウントを削除すると、</p>
          <p class="font-weight-bold text-h6">今まで作成したトピックやお気に入り一覧等は使用できなくなり、</p>
          <p class="font-weight-bold text-h6">vla.tipsアカウントは全て削除されます</p>
        </v-col>
      </v-row>
    </v-card-text>
    <v-row justify="center">
      <v-col cols="12" md="9">
        <v-row justify="center">
          <v-btn @click="leave" color='#ED4646' center outlined width="180" class="font-weight-bold">
            削除する
          </v-btn>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      selectedItem: 3,
      user_code: '',
      user: {
        name: '',
        user_code: '',
      },
    };
  },
  methods: {
    leave() {
      this.$store.dispatch('auth/leave')
        .then(() => {
          this.$router.push('/');
        })
    },
    linkToProfile() {
      this.$router.push({name: 'user', params: {user_code: this.user.user_code}})
    }
  },
  computed: {
    getUserCode: function() {
      return this.$store.getters['auth/isUserCode']
    }
  },
  mounted: function () {
    this.user_code = this.getUserCode;
    this.$axios.get(process.env.VUE_APP_API_BASE_URL + '/user/' + this.user_code)
      .then(response => {
        this.user = response.data
      });
  },
};
</script>